module.exports = __webpack_public_path__ + "fonts/geograph-web-bold.c1bca308.woff";